import React, { CSSProperties, FC, PropsWithChildren } from 'react';
import { LinkTrackable } from 'components/Trackable/LinkTrackable';
import { StandardCover } from 'types/Cover';

type PropTypes = PropsWithChildren<{
    cover: StandardCover;
    style?: CSSProperties;
}>;

export const CardLink: FC<PropTypes> = ({ cover, style, children, ...rest }) => {
    const { path, onClick, renderPlayIcon, onPlayIconClicked, rawData } = cover;

    if (!path) {
        return <div style={{ ...style, cursor: 'default' }}>{children}</div>;
    }

    return (
        <LinkTrackable
            to={path}
            onClick={(e) => {
                if (onClick) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (renderPlayIcon) {
                        onPlayIconClicked(e);
                    } else {
                        onClick(e, rawData);
                    }
                }
            }}
            visibleFocus="outline"
            style={style}
            {...rest}
        >
            {children}
        </LinkTrackable>
    );
};
